<template>
    <div>
        <cis-with-detail
        :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sideBarData"
        >

        </cis-with-detail>
        <vs-table id="orderLogsTable" :max-items="itemsPerPage" :data="wants"
        @selected="handleSelected">
        <div
          slot="header"
          class="w-full flex flex-wrap items-center flex-grow justify-between"
        >
          <vs-row vs-type="flex" vs-w="12" class="mb-1">
            <global-filter
              ref="filterer"
              :tableOptions="tableOptions"
              :filterOptions="filterOptions"
              :filterChips="filterChips"
              :filterOptionNames="filterOptionNames"
              :isActive="isFilterActive"
              @saveOptions="saveOptions"
              @close="isFilterActive = false"
            />
            <vs-row
              id="panelHeaderRow"
              v-show="!isFilterActive"
              vs-type="flex"
              vs-w="12"
              vs-justify="space-between"
            >
              <vs-col
                id="panel-actions"
                vs-type="flex"
                class="w-auto"
                vs-justify="center"
              >
                <vs-row style="margin-top: 1rem; margin-left: 1rem;" vs-type="flex" vs-w="12">
                  <vs-col vs-type="flex" class="w-auto">
                    <vx-tooltip text="Yeni İstek" position="top">
                      <vs-button
                      @click="newFormPopupActive = true"
                      class="panel-action text-success xlarge-button panel-action-box-shadow"
                      color="transparent"
                      icon-pack="feather"
                      icon="icon-plus"
                    >
                    </vs-button>
                </vx-tooltip>
                </vs-col>
                  <vs-col vs-type="flex" class="w-auto">
                    <vx-tooltip text="Detaylı Filtereleme" position="top">
                      <vs-button
                        @click="isFilterActive = !isFilterActive"
                        class="panel-action text-warning xlarge-button panel-action-box-shadow"
                        color="transparent"
                        icon-pack="pickicon"
                        icon="icon-pick-filter"
                      >
                      </vs-button>
                    </vx-tooltip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col id="filter-chips" vs-type="flex">
                <vs-row
                  vs-type="flex"
                  vs-w="12"
                  vs-justify="center"
                  vs-align="center"
                >
                  <vs-button
                    id="clearFilterButton"
                    v-if="filterChips.length > 0"
                    @click="clearFilter"
                    class="mr-2 bg-white text-danger panel-action-box-shadow"
                    icon-pack="feather"
                    icon="icon-slash"
                    radius
                    color="transparent"
                  />
                  <vs-col
                    vs-type="flex"
                    class="w-auto"
                    v-for="(chip, index) in filterChips"
                    :key="index"
                  >
                    <vs-chip
                      color="white"
                      class="panel-action-box-shadow px-1"
                      @click="removeFilter(chip.col, index)"
                      v-show="chip.value != ''"
                      closable
                    >
                      <vs-row vs-tpye="flex" vs-w="12">
                        <vs-col vs-tpye="flex" class="w-auto" vs-align="center">
                          <span class="bold text-xsmaller text-dark">
                            {{ chip.name + " :" }}
                          </span>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          class="w-auto ml-1"
                          vs-align="center"
                        >
                          <feather-icon
                            v-if="chip.value === true"
                            icon="CheckIcon"
                            svgClasses="w-4 h-4 text-primary"
                          />
                          <feather-icon
                            v-else-if="chip.value === false"
                            icon="XIcon"
                          />
                          <span
                            v-else
                            class="weight-600 italic text-xsmaller text-primary"
                          >
                            {{ chip.value }}
                          </span>
                        </vs-col>
                      </vs-row>
                    </vs-chip>
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col
                id="table-page-size"
                vs-type="flex"
                class="w-auto"
                vs-justify="flex-end"
              >
                <vs-dropdown
                  vs-trigger-click
                  class="bg-white cursor-pointer panel-action-box-shadow"
                >
                  <div
                    class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
                  >
                    <span class="mr-2 page-size-dropdown-span"
                      >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                      -
                      {{
                        totalDataRow - (currentPage + 1) * itemsPerPage > 0
                          ? (currentPage + 1) * itemsPerPage
                          : totalDataRow
                      }}
                      of
                      {{ totalDataRow }}</span
                    >
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage = 10">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage = 15">
                      <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage = 20">
                      <span>20</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-col>
            </vs-row>
          </vs-row>
        </div>

        <template slot="thead">
          <vs-th class="w-1/12 px-1">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'id' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('id')"
              >Id
            </vs-button>
          </vs-th>
          <vs-th class="w-2/12">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'title' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('title')"
              >Başlık
            </vs-button>
          </vs-th>
          <vs-th class="w-2/12">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="tableOptions.sortBy == 'created' ? sortingHeadIcon : null"
              color="primary"
              type="flat"
              @click="setSortingOptions('created')"
              >Oluşt. Tar.
            </vs-button>
          </vs-th>
          <vs-th class="w-3/12 px-1">
            <vs-button
              class="p-1 weight-600"
              icon-pack="feather"
              :icon="
                tableOptions.sortBy == 'status' ? sortingHeadIcon : null
              "
              color="primary"
              type="flat"
              @click="setSortingOptions('status')"
              >Durum
            </vs-button>
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-1/12 text-center">
              {{ tr.id }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
              {{ tr.title }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
              {{ tr.createdText }}
            </vs-td>
            <vs-td class="w-2/12 text-center">
              {{ tr.statusText }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-row vs-type="flex" vs-w="12">
        <pagination-default
          :setCurrentPage="tableOptions.pageIndex"
          :totalLenght="calculatePageLength"
          @currentPage="getCurrentPage"
        ></pagination-default>
      </vs-row>


    <!-- <vs-table search max-items="10" pagination :data="wants" @selected="handleSelected">
      <template slot="header">
        <h3 style="margin-left: 5rem;">
          İletişim Formları
        </h3>
        <vs-button @click="newFormPopupActive = true" style="margin-left: 5rem;" color="success" type="filled">Yeni İstek</vs-button>

      </template>
      <template slot="thead">
        <vs-th sort-key="id" class="w-2/12">
          Id
        </vs-th>
        <vs-th sort-key="title" class="w-2/12">
          Başlık
        </vs-th>
        <vs-th sort-key="statusText" class="w-2/12">
          Durum
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].email">
            {{data[indextr].id}}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].title}}
          </vs-td>

          <vs-td :data="data[indextr].id">
            {{data[indextr].statusText}}
          </vs-td>
        </vs-tr>
      </template>


    </vs-table> -->

    <vs-popup fullscreen title="Yeni İstek" :active.sync="newFormPopupActive">
        <vs-row vs-w="12">
  <vs-col vs-offset="3" vs-justify="center" vs-align="center" vs-w="6" class="px-2">
    <form data-vv-scope="form-1" @keyup.enter="submitData">
        <vs-row class="mb-6">
    <div class="w-full">
    <vs-input label-placeholder="İstek Başlığı" v-validate="'required|min:2|max:60'" name="Başlık" v-model="newWant.title" class="w-full" size="large" vs-type="flex"/>
    <span class="text-danger text-sm" v-show="errors.has('form-1.Başlık')">{{ errors.first('form-1.Başlık')}}</span>
</div>
   </vs-row>
   <vs-row class="mb-6">
          <div class="w-full">
            <v-select
              v-model="newWant.category"
              :options="categories"
              itemid="id" label="name"
              v-validate="'required'"
              name="Kategori" placeholder="Kategori Seçimi.."
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('form-1.Kategori')">{{ errors.first('form-1.Kategori')}}</span>
          </div>
        </vs-row>
  <vs-row class="mb-6">
        <div class="w-full">
    <vs-textarea label="İstek İçeriği" name="İçerik" v-validate="'required|min:2'" size="large" v-model="newWant.content" />
    <span class="text-danger text-sm" v-show="errors.has('form-1.İçerik')">{{ errors.first('form-1.İçerik')}}</span>
  </div>
    </vs-row>

    <!-- File Upload Section -->
    <vs-row class="mb-6">
      <div class="w-full">
        <label class="vs-input--label">Dosyalar (Toplam max. 3MB)</label>
        <div class="file-upload-container">
          <input
            type="file"
            ref="fileInput"
            @change="handleFileUpload"
            multiple
            class="hidden"
          />
          <vs-button
            icon-pack="feather"
            icon="icon-upload"
            @click="$refs.fileInput.click()"
            :disabled="totalFileSize >= maxTotalSize"
          >
            Dosya Ekle
          </vs-button>
          <div v-if="totalFileSize > 0" class="mt-2">
            <span :class="{'text-danger': totalFileSize > maxTotalSize, 'text-success': totalFileSize <= maxTotalSize}">
              Toplam: {{ formatFileSize(totalFileSize) }} / 3MB
            </span>
          </div>
        </div>

        <!-- Selected Files List -->
        <div v-if="selectedFiles.length > 0" class="selected-files mt-3">
          <div class="files-heading mb-2">
            <feather-icon icon="FileTextIcon" svgClasses="h-5 w-5 text-primary mr-1"></feather-icon>
            <span>Seçilen Dosyalar</span>
          </div>
          <ul class="file-list">
            <li v-for="(file, index) in selectedFiles" :key="index" class="file-item">
              <div class="file-info">
                <feather-icon icon="FileIcon" svgClasses="h-5 w-5 text-primary mr-2"></feather-icon>
                <span class="file-name">{{ file.name }} ({{ formatFileSize(file.size) }})</span>
              </div>
              <div class="file-actions">
                <vs-button
                  color="danger"
                  icon-pack="feather"
                  icon="icon-x"
                  size="small"
                  @click="removeFile(index)"
                ></vs-button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </vs-row>
    <!-- End File Upload Section -->

    <vs-row class="mb-6 " vs-type="flex" vs-w="12">
            <vs-col class="w-full" vs-justify="flex-end" vs-type="flex">
              <vs-button size="large" class="mr-3 mb-2 " type="gradient" color="danger"
                @click="initNewFormValues()">
                Vazgeç
              </vs-button>
              <vs-button size="large" class="mb-2 " type="gradient" color="success" @click="submitData">Kaydet

              </vs-button>

            </vs-col>
          </vs-row>
    </form>

  </vs-col>
</vs-row>

    </vs-popup>
  </div>
  </template>

  <script>
  import { addUserWant, getAll, getLogs, uploadFile } from "@/api/UserWant";
  import { getAllUserWantCategories } from "@/api/UserWantCategory";
  import CisWithDetail from "./CisWithDetail.vue";
  import PaginationDefault from "../PaginationDefault";
  import GlobalFilter from "../GlobalFilter";
export default {
    components:{
        CisWithDetail,
        PaginationDefault,
      GlobalFilter,
    },
    data() {
        return{
    categories: [],
    wants:[],
    newFormPopupActive: false,
    newWant:{
        title:"",
        content:"",
        files: []
    },
    addNewDataSidebar: false,
    sideBarData: {},
    tableOptions: {},
        sortingHeadIcon: "",
        sortingHeadIconBool: 1,
        currentPage: 0,
        itemsPerPage: 10,
        totalDataRow: 0,
        dayReports: [],
        isFilterActive: false,
        filterOptions: [
          "dateRange",
          "UserWantStatus"
        ],
        filterOptionNames: [
          "Tarih",
          "İstekDurumu"
        ],
        isFiltererOpen: false,
        filterChips: [],
        selected: "",
        totalFileSize: 0,
        maxTotalSize: 3 * 1024 * 1024, // 3MB
        selectedFiles: []
  }},
  created:async function(){
    await this.loadCategories();
    this.clearFilter();
    delete this.tableOptions["dateRange"];
  },
  watch:{
    tableOptions: {
        deep: true,
        handler(val) {
          this.$nextTick(() => {
            this.getDatas();
          });
        },
      },
      currentPage: function (val) {
        this.tableOptions.pageIndex = val;
      },
      sortingHeadIconBool: function () {
        switch (this.sortingHeadIconBool) {
          case 1:
            this.tableOptions.sortDirection = "";
            break;
          case 2:
            this.tableOptions.sortDirection = "asc";
            break;
          case 3:
            this.tableOptions.sortDirection = "desc";
            break;
        }
        this.currentPage = 0;
        this.tableOptions.pageIndex = this.currentPage;
      },
      itemsPerPage: function (val) {
        this.currentPage = 0;
        this.tableOptions.pageSize = val;
        this.tableOptions.pageIndex = this.currentPage;
      }
  },
  computed:{
    calculatePageLength() {
        let mod = this.totalDataRow % this.itemsPerPage;
        return mod > 0
          ? (this.totalDataRow - mod) / this.itemsPerPage + 1
          : this.totalDataRow / this.itemsPerPage;
      }
  },
  methods:{
    saveOptions(filterOptions, filterChips) {
        console.log(filterChips);
        console.log(filterOptions);
        this.isFilterActive = false;
        if (_.isEqual(this.tableOptions, filterOptions)) return;
        this.tableOptions = _.cloneDeep(filterOptions);
        this.filterChips = _.cloneDeep(filterChips);
      },
      clearFilter() {
        this.tableOptions = {
          sortBy: "Created",
          sortDirection: "desc",
          pageIndex: 0,
          pageSize: this.itemsPerPage,
          dateRange: {
            startDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
            endDate:
              this.$now().getHours() >= 0 && this.$now().getHours() <= 2
                ? this.$preDate()
                : this.$now.date(),
          },
          timeRange: {
            startTime: null,
            endTime: null,
          },
          paymentMethod: null,
          extra: null,
          product: null,
          personal: null,
          order: null,
          price: {
            min: null,
            max: null,
          },
          branch: this.$currentUser.branch,
          dayReportType:null
        };
        this.filterChips.length = 0;
      },
      removeFilter(col, index) {
        //if (col === "branch") this.tableOptions[col] = this.$currentUser.branch;
         this.tableOptions[col] = null;
        this.filterChips.splice(index, 1);
      },
      setSortingOptions(val) {
        if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
        this.tableOptions.sortBy = val;
        switch (this.sortingHeadIconBool) {
          case 1:
            this.sortingHeadIconBool++;
            this.sortingHeadIcon = "icon-arrow-up";
            break;
          case 2:
            this.sortingHeadIconBool++;
            this.sortingHeadIcon = "icon-arrow-down";
            break;
          case 3:
            this.sortingHeadIconBool = 1;
            this.sortingHeadIcon = "";
            this.tableOptions.sortBy = "";
        }
      },
      getCurrentPage(currentx) {
        this.currentPage = currentx - 1;
      },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    handleSelected(tr) {
      this.sideBarData = tr;
      this.toggleDataSidebar(true)

    },
    getDatas() {
        getAll(this.tableOptions).then((res)=>{
            if (res && res.status == 200) {
              this.wants = res.data.items;
              this.totalDataRow = res.data.totalCount;
            }else{
                this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Hata : " + res.status,
              });
            }
        })
    }
    ,
    initNewFormValues(){
        this.newWant = {
          title: "",
          content: "",
          files: []
        }
        this.selectedFiles = [];
        this.totalFileSize = 0;
        this.newFormPopupActive = false
        this.$validator.reset();
    },
    submitData: async function () {
        console.log('bastı');
        let checker;
        checker = await this.$validator.validateAll("form-1");
        if(checker){
            try {
                console.log('true');
                // Dosya yükleme işlemi
                if (this.selectedFiles.length > 0) {
                    console.log("Dosyalar yükleniyor:", this.selectedFiles);
                    const filePaths = await this.uploadSelectedFiles();
                    console.log("Yüklenen dosya yolları:", filePaths);
                    this.newWant.files = filePaths;
                } else {
                    this.newWant.files = [];
                }

                this.newWant.categoryId = this.newWant.category.id;
                // Dosya yollarını kontrol et
                if (this.newWant.files && this.newWant.files.length > 0) {
                  console.log("Eklenen dosya yolları:", this.newWant.files);
                } else {
                  console.log("Hiç dosya eklenmedi");
                }
                console.log("Gönderilecek veri:", JSON.stringify(this.newWant));
                const res = await addUserWant(this.newWant);

                if (res && res.status == 200) {
                    this.initNewFormValues();
                    this.getDatas();
                    this.$vs.notify({
                      color: 'success',
                      title: 'Başarılı !',
                      text: 'İstek Ekleme Başarılı ! '
                    });
                } else {
                  this.$vs.notify({
                    color: 'danger',
                    title: 'Hata !',
                    text: 'İstek Ekleme Başarısız ! '
                  });
                }
            } catch (error) {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata !',
                  text: error.response.data.Errors[0].Message
                });
            }
        }
    },
    async loadCategories() {
      try {
        const response = await getAllUserWantCategories();
        this.categories = response.data;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Kategoriler yüklenirken bir hata oluştu!"
        });
      }
    },
    handleFileUpload(event) {
      console.log("Dosya seçildi:", event.target.files);
      const newFiles = Array.from(event.target.files);

      // Check if adding these files would exceed the limit
      const newTotalSize = this.totalFileSize + newFiles.reduce((total, file) => total + file.size, 0);

      if (newTotalSize > this.maxTotalSize) {
        this.$vs.notify({
          color: 'danger',
          title: 'Hata!',
          text: 'Toplam dosya boyutu 3MB\'ı geçemez!'
        });
        // Reset file input
        this.$refs.fileInput.value = '';
        return;
      }

      // Add files to the selected files array
      this.selectedFiles = [...this.selectedFiles, ...newFiles];

      // Update total size
      this.totalFileSize = newTotalSize;

      // Reset file input
      this.$refs.fileInput.value = '';
    },
    removeFile(index) {
      // Update total size before removing file
      this.totalFileSize -= this.selectedFiles[index].size;

      // Remove file from array
      this.selectedFiles.splice(index, 1);
    },
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      }
    },
    async uploadSelectedFiles() {
      if (this.selectedFiles.length === 0) return [];

      const filePaths = [];

      // Upload each file individually
      for (const file of this.selectedFiles) {
        try {
          console.log("Yüklenecek dosya:", file);
          const formData = new FormData();
          formData.append('image', file);
          console.log("FormData hazırlandı");

          const response = await uploadFile(formData);
          console.log("Dosya yükleme cevabı:", response);
          if (response && response.status === 200) {
            // Add the path to our array
            filePaths.push("StaticFiles/images/" + response.data);
          }
        } catch (error) {
          console.error("Dosya yükleme hatası:", error);
          this.$vs.notify({
            color: 'danger',
            title: 'Hata!',
            text: `${file.name} dosyası yüklenirken hata oluştu`
          });
        }
      }

      return filePaths;
    }
  }
}
</script>

<style scoped>
/* File upload styles */
.file-upload-container {
  margin-top: 8px;
}

.file-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: #f8f8f8;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.file-item:hover {
  background-color: #f1f5f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.file-info {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.file-name {
  font-size: 0.875rem;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.file-actions {
  display: flex;
  gap: 5px;
  align-items: center;
}

.mr-2 {
  margin-right: 0.5rem;
}

.files-heading {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
  font-weight: 600;
  color: #333;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.text-danger {
  color: #dc3545;
}

.text-success {
  color: #28a745;
}
</style>
